<app-breadcrumb [title]="'Notificaciones'" [items]="['Notificaciones']" [active_item]="'Configuración de notificaciones'"></app-breadcrumb>

<div class="container-fluid">
 <section class="pagina">

  <header class="encabezado">
    <div class="titulo">
      <div class="icono-principal">
         <i class="icofont icofont-envelope"></i>       
      </div>

      <div>
        <h1>Destinatarios de notificaciones</h1>
        <p>Administra los correos que reciben las alertas de Admin SEAF.</p>
      </div>
    </div>

    <button class="btn-principal" type="button" (click)="nuevo()">
      + Nuevo destinatario
    </button>
  </header>

  <div class="alerta alerta-error" *ngIf="error">
    {{ error }}
  </div>

  <div class="alerta alerta-ok" *ngIf="mensaje">
    {{ mensaje }}
  </div>

  <div class="resumen">
    <article class="tarjeta-resumen">
      <span class="resumen-icono"><i class="icofont icofont-users"></i></span>
      <div>
        <p>Destinatarios registrados</p>
        <strong>{{ destinatarios.length }}</strong>
      </div>
    </article>

    <article class="tarjeta-resumen">
      <span class="resumen-icono"><i class="icofont icofont-check-circled"></i></span>
      <div>
        <p>Destinatarios activos</p>
        <strong>{{ totalDestinatariosActivos }}</strong>
      </div>
    </article>

    <article class="tarjeta-resumen">
      <span class="resumen-icono"><i class="icofont icofont-envelope"></i></span>
      <div>
        <p>Con alertas habilitadas</p>
        <strong>{{ totalDestinatariosConAlertas }}</strong>
      </div>
    </article>
  </div>

  <section class="panel">

    <div class="panel-cabecera">
      <div>
        <h2>Listado de destinatarios</h2>
        <p>Configura las notificaciones que recibe cada usuario.</p>
      </div>

      <input
        type="search"
        class="buscador"
        placeholder="Buscar por nombre o correo..."
        [(ngModel)]="busqueda"
      
        aria-label="Buscar destinatarios"
      />
    </div>

    <div class="tabla-contenedor">
      <table>
        <thead>
          <tr>
            <th>Destinatario</th>
            <th>Vehículos</th>
            <th>Conductores</th>
            <th>Vencimientos</th>
            <th>Estado</th>
            <th class="acciones-col">Acciones</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngIf="cargando">
            <td colspan="6" class="estado-vacio">Cargando destinatarios...</td>
          </tr>

          <tr *ngFor="let d of destinatariosFiltrados">
            <td>
              <div class="usuario">
                <div class="avatar">
                  {{ d.nombre.charAt(0).toUpperCase() }}
                </div>

                <div>
                  <strong>{{ d.nombre }}</strong>
                  <span>{{ d.correo }}</span>
                </div>
              </div>
            </td>

            <td>
              <span class="estado"
                [class.estado-si]="d.recibir_vehiculos"
                [class.estado-no]="!d.recibir_vehiculos">
                {{ d.recibir_vehiculos ? 'Habilitado' : 'No recibe' }}
              </span>
            </td>

            <td>
              <span class="estado"
                [class.estado-si]="d.recibir_conductores"
                [class.estado-no]="!d.recibir_conductores">
                {{ d.recibir_conductores ? 'Habilitado' : 'No recibe' }}
              </span>
            </td>

            <td>
              <span class="estado"
                [class.estado-si]="d.notificar_vencidos"
                [class.estado-no]="!d.notificar_vencidos">
                {{ d.notificar_vencidos ? 'Habilitado' : 'Deshabilitado' }}
              </span>
            </td>

            <td>
              <span class="estado"
                [class.estado-si]="d.activo"
                [class.estado-no]="!d.activo">
                {{ d.activo ? 'ACTIVO' : 'INACTIVO' }}
              </span>
            </td>

            <td>
              <div class="acciones">
                <button
                  class="btn-icono"
                  type="button"
                  title="Editar destinatario"
                  aria-label="Editar destinatario"
                  (click)="editar(d)">
                  ✎
                </button>

                <!-- <button
                  class="btn-secundario"
                  type="button"
                  (click)="cambiarEstado(d)">
                  {{ d.activo ? 'Desactivar' : 'Activar' }}
                </button> -->
              </div>
            </td>
          </tr>

          <tr *ngIf="!cargando && destinatariosFiltrados.length === 0">
            <td colspan="6" class="estado-vacio">
              No se encontraron destinatarios.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <!-- Formulario de creación y edición -->
 
<div class="modal-fondo" *ngIf="mostrarFormulario">
  <section
    class="modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="tituloFormulario">

    <!-- Encabezado -->
    <header class="modal-cabecera">
      <div class="modal-titulo">
        <h2 id="tituloFormulario">
          {{ editandoId !== null
              ? 'Editar destinatario'
              : 'Nuevo destinatario' }}
        </h2>

        <p>Configura los datos y tipos de notificación.</p>
      </div>

      <button
        class="btn-cerrar"
        type="button"
        (click)="cancelar()"
        aria-label="Cerrar formulario">
        <i class="icofont icofont-close"></i>
      </button>
    </header>

    <form [formGroup]="formulario" (ngSubmit)="guardar()" novalidate>

      <!-- Nombre completo -->
      <div class="campo-formulario">
        <label for="nombre">
          Nombre completo
          <span class="campo-obligatorio">*</span>
        </label>

        <div
          class="campo-con-icono"
          [class.campo-invalido]="
            formulario.controls.nombre.touched &&
            formulario.controls.nombre.invalid
          ">

          <i class="icofont icofont-user campo-icono"
             aria-hidden="true"></i>

          <input
            id="nombre"
            type="text"
            formControlName="nombre"
            placeholder="Ej. Coordinador de flota"
            maxlength="150"
            autocomplete="name"
            [attr.aria-invalid]="
              formulario.controls.nombre.touched &&
              formulario.controls.nombre.invalid
            "
            [attr.aria-describedby]="
              formulario.controls.nombre.touched &&
              formulario.controls.nombre.invalid
                ? 'errorNombre'
                : null
            " />
        </div>

        <small
          id="errorNombre"
          class="campo-error"
          *ngIf="
            formulario.controls.nombre.touched &&
            formulario.controls.nombre.invalid
          ">

          <i class="icofont icofont-exclamation-circle"
             aria-hidden="true"></i>

          <span *ngIf="formulario.controls.nombre.errors?.['required']">
            El nombre completo es obligatorio.
          </span>

          <span *ngIf="formulario.controls.nombre.errors?.['maxlength']">
            El nombre no puede superar los 150 caracteres.
          </span>
        </small>
      </div>

      <!-- Correo electrónico -->
      <div class="campo-formulario">
        <label for="correo">
          Correo electrónico
          <span class="campo-obligatorio">*</span>
        </label>

        <div
          class="campo-con-icono"
          [class.campo-invalido]="
            formulario.controls.correo.touched &&
            formulario.controls.correo.invalid
          ">

          <i class="icofont icofont-envelope campo-icono"
             aria-hidden="true"></i>

          <input
            id="correo"
            type="email"
            formControlName="correo"
            placeholder="usuario@empresa.com"
            maxlength="254"
            autocomplete="email"
            [attr.aria-invalid]="
              formulario.controls.correo.touched &&
              formulario.controls.correo.invalid
            "
            [attr.aria-describedby]="
              formulario.controls.correo.touched &&
              formulario.controls.correo.invalid
                ? 'errorCorreo'
                : null
            " />
        </div>

        <small
          id="errorCorreo"
          class="campo-error"
          *ngIf="
            formulario.controls.correo.touched &&
            formulario.controls.correo.invalid
          ">

          <i class="icofont icofont-exclamation-circle"
             aria-hidden="true"></i>

          <span *ngIf="formulario.controls.correo.errors?.['required']">
            El correo electrónico es obligatorio.
          </span>

          <span *ngIf="formulario.controls.correo.errors?.['email']">
            Ingresa un correo electrónico válido.
          </span>

          <span *ngIf="formulario.controls.correo.errors?.['maxlength']">
            El correo no puede superar los 254 caracteres.
          </span>
        </small>
      </div>

      <div class="separador"></div>

      <!-- Tipos de notificación -->
      <section class="seccion-notificaciones">
        <h3>Tipos de notificación</h3>

        <p class="descripcion-seccion">
          Selecciona las alertas que recibirá este destinatario.
        </p>

        <!-- Vehículos -->
        <label class="opcion">
          <input
            type="checkbox"
            formControlName="recibir_vehiculos"
            aria-label="Recibir notificaciones de vehículos" />

          <span class="opcion-icono">
            <i class="icofont icofont-car"
               aria-hidden="true"></i>
          </span>

          <span class="opcion-contenido">
            <strong>Documentos de vehículos</strong>
            <small>
              SOAT, revisión técnico-mecánica, RCC, RCE y otros.
            </small>
          </span>
        </label>

        <!-- Conductores -->
        <label class="opcion">
          <input
            type="checkbox"
            formControlName="recibir_conductores"
            aria-label="Recibir notificaciones de conductores" />

          <span class="opcion-icono">
            <i class="icofont icofont-users"
               aria-hidden="true"></i>
          </span>

          <span class="opcion-contenido">
            <strong>Documentos de conductores</strong>
            <small>
              Alertas sobre vencimientos documentales de conductores.
            </small>
          </span>
        </label>

        <!-- Vencimientos -->
        <label class="opcion">
          <input
            type="checkbox"
            formControlName="notificar_vencidos"
            aria-label="Habilitar notificaciones de vencimientos" />

          <span class="opcion-icono">
            <i class="icofont icofont-alarm"
               aria-hidden="true"></i>
          </span>

          <span class="opcion-contenido">
            <strong>Notificar vencimientos</strong>
            <small>
              Habilita el envío de alertas de vencimiento.
            </small>
          </span>
        </label>

        <!-- Estado del destinatario -->
        <label class="opcion">
          <input
            type="checkbox"
            formControlName="activo"
            aria-label="Activar destinatario" />

          <span class="opcion-icono">
            <i class="icofont icofont-user-alt-3"
               aria-hidden="true"></i>
          </span>

          <span class="opcion-contenido">
            <strong>Destinatario activo</strong>
            <small>
              Permite incluirlo en el proceso de notificaciones.
            </small>
          </span>
        </label>
      </section>

      <!-- Error del servidor -->
      <div
        class="alerta alerta-error"
        role="alert"
        *ngIf="errorModal">

        <i class="icofont icofont-warning"
           aria-hidden="true"></i>

        <span>{{ errorModal }}</span>
      </div>

      <!-- Acciones -->
      <footer class="modal-acciones">
        <button
          class="btn-secundario"
          type="button"
          (click)="cancelar()"
          [disabled]="guardando">
          Cancelar
        </button>

        <button
          class="btn-principal"
          type="submit"
          [disabled]="guardando">

          <i
            *ngIf="guardando"
            class="icofont icofont-spinner-alt-4"
            aria-hidden="true"></i>

          <i
            *ngIf="!guardando"
            class="icofont icofont-save"
            aria-hidden="true"></i>

          {{ guardando
              ? 'Guardando...'
              : editandoId !== null
                ? 'Guardar cambios'
                : 'Guardar destinatario' }}
        </button>
      </footer>

    </form>
  </section>
</div>


</section>
</div>